module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    ref: _vm.getTableRef(),
    attrs: {
      "id": _vm.getTableRef(),
      "title": _vm.title,
      "url": _vm.url,
      "table-ref": _vm.getTableRef(),
      "fields": _vm.fields,
      "hideTop": _vm.hideTop,
      "showSearch": _vm.showSearch,
      "org-badge": _vm.orgBadge,
      "showRefresh": _vm.showRefresh,
      "searchPlaceholder": _vm.searchPlaceholder,
      "add-action": (_vm.uploadInfo || _vm.uploadCallback) ? _vm.addFileAction : null,
      "add-props": _vm.addProps,
      "show-pagination": _vm.showPagination,
      "options": _vm.detailProps,
      "detail-component": "file-detail-row"
    },
    scopedSlots: _vm._u([{
      key: "file-action",
      fn: function(props) {
        return [_c('el-form', [(!props.rowData.url) ? _c('file-upload', {
          attrs: {
            "text": 'Upload ' + props.rowData.title,
            "url": _vm.getEndpoint('/upload/' +
              props.rowData.id + '/site/' +
              props.rowData.site_id + '/' + _vm.userName()),
            "delete-file-only": true,
            "after-upload": _vm.uploaded,
            "after-delete": _vm.afterDelete,
            "model": _vm.getModel(props.rowData.id),
            "type": "primary",
            "show-tooltip": true,
            "size": _vm.size,
            "additional-data": this.uploadInfo,
            "disabled": _vm.isViewOnly() || _vm.disableUpload(props.rowData)
          }
        }) : _c('div', [_c('el-button', {
          attrs: {
            "type": _vm.getType(props.rowData),
            "size": _vm.size,
            "disabled": _vm.isViewOnly()
          },
          on: {
            "click": function($event) {
              return _vm.download(props.rowData)
            }
          }
        }, [_c('b', [_vm._v("Download " + _vm._s(props.rowData.title))])]), _vm._v(" "), (_vm.showFileName && _vm.isDesktop) ? _c('p', [_c('small', [_c('i', [_vm._v(_vm._s(props.rowData.name))])])]) : _vm._e()], 1)], 1)]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-763a6fc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/FilesTable.vue
// module id = 1645
// module chunks = 0